import { apiRequest } from "../index";

export const getAllOffers = async ({ page = 1, limit = 10, ...filters }) => {
  const params = new URLSearchParams();
  params.append("page", page);
  params.append("limit", limit);

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined) {
      params.append(key, value);
    }
  });

  return apiRequest(`/api/common/offers?${params.toString()}`, "GET");
};

export const getOfferById = async (offerId) => {
  return apiRequest(`/api/common/offers/${offerId}`, "GET");
};

export const addOfferForAll = async (formData) => {
  return apiRequest(`/api/common/offers`, "POST", formData,true);
};

export const updateOffer = async (offerId, data) => {
  return apiRequest(`/api/common/offers/${offerId}`, "PUT",  data , true);
};

export const getRestaurantOrHotels = async ({ query }) => {
  const { restaurant } = query;
  const endpoint = `/api/common/offers/restaurants/hotels?restaurant=${restaurant || 'false'}`;
  return apiRequest(endpoint, 'GET');
};
